module.exports = __webpack_public_path__ + "img/play-store-badge.4df90d4d.png";